// eslint-disable-next-line import/extensions
import BaseService from '@/services/base.service';

const initialState = {
  smsTemplates: []
};

const getters = {
  getSMSTemplates: (state) => (state.smsTemplates ? state.smsTemplates.reduce((a, v) => ({ ...a, [v.uuid]: v.name }), {}) : {}),
  getSMSTemplatesFull: (state) => state.smsTemplates
};

const actions = {
  async fetchSMSTemplates({ rootState, commit }, { id }) {
    let organizationId = id;
    const workflowService = new BaseService();

    if (!organizationId) {
      const { uuid } = rootState.organization;
      organizationId = uuid;
    }

    const { data: { status, result } } = await workflowService.get(`template/sms/${organizationId}`);

    if (status === 'success') {
      commit('setSMSTemplates', result);
      return Promise.resolve(result);
    }

    return Promise.reject();
  },

  async createSMSTemplate({ rootState }, { id, payload }) {
    let organizationId = id;
    const workflowService = new BaseService();

    if (!organizationId) {
      const { uuid } = rootState.organization;
      organizationId = uuid;
    }

    const { data: { status } } = await workflowService.create(`template/sms/${organizationId}`, payload);

    if (status === 'success') {
      return Promise.resolve();
    }

    return Promise.reject();
  },

  // eslint-disable-next-line no-empty-pattern
  async updateSMSTemplate({}, { uuid, ...payload }) {
    const workflowService = new BaseService();

    const { data: { status } } = await workflowService.create(`template/sms_edit/${uuid}`, payload);

    if (status === 'success') {
      return Promise.resolve();
    }

    return Promise.reject();
  },

  // eslint-disable-next-line no-empty-pattern
  async deleteSMSTemplate({}, uuid) {
    const workflowService = new BaseService();

    const { data: { status } } = await workflowService.create(`template/sms_delete/${uuid}`);

    if (status === 'success') {
      return Promise.resolve();
    }

    return Promise.reject();
  }
};

const mutations = {
  setSMSTemplates(state, smsTemplates) {
    state.smsTemplates = smsTemplates;
  },
  cleanSMSTemplates(state) {
    state.smsTemplates = [];
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
